// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.swal2-container[data-v-29f1ee44] {\n  z-index: 100000002 !important;\n}\n.v-input[data-v-29f1ee44] {\n  font-size: 13px !important;\n}\n.v-input--selection-controls[data-v-29f1ee44] {\n  margin-top: 0px;\n  padding-top: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
